import { Loader2 } from 'lucide-react';

import { MessageHistoryView } from '@/components/messages/MessageHistoryView';
import { useAuth } from '@/hooks/use-auth';
import { useMessages } from '@/hooks/use-messages';

export default function MessagesPage() {
  const { serviceId } = useAuth();
  const { data, isLoading, isError } = useMessages(serviceId ?? '');

  const messages = Array.isArray(data) ? data : [];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center py-12">
        <p className="text-sm text-destructive">
          Failed to load messages. Please try again later.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Messages</h1>
      <MessageHistoryView messages={messages} />
    </div>
  );
}
